import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LazyClientShow',
  props: {
    hydrate: { default: 'when-idle' },
    forceRenderOnServer: { type: Boolean }
  },
  setup(__props: any) {



const isMounted = ref(false);

onMounted(() => (isMounted.value = true));

return { __sfc: true,isMounted }
}

})